'use client';

import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import { cn } from '@/lib/cn';
import type { CmsFleetCategory } from '@/services/cms-sdk';
import { useVehicleCompareState } from './VehicleCompareContext';
import type { StoredFleetCategory } from './types';

export interface ToggleCompareProps {
    className?: string;
    fleetCategory: CmsFleetCategory;
    variant?: 'icon' | 'text';
}

export function ToggleCompare({ className, fleetCategory, variant = 'text' }: ToggleCompareProps) {
    const { categories, categoryCount, toggleCategory } = useVehicleCompareState();
    const isChecked = categories.some((c) => c?.code === fleetCategory.code && c?.region === fleetCategory.region);
    const itemId = `${fleetCategory.code}-${fleetCategory.region}`;
    const category = {
        code: fleetCategory.code,
        region: fleetCategory.region,
    } as StoredFleetCategory;
    const toggle = () => toggleCategory(category);

    if (variant === 'text') {
        return (
            <div className={cn('bg-badge-content rounded-[8px] px-[10px] py-[6px] inline-flex flex-row h-[36px] items-center overflow-hidden', className)}>
                <label htmlFor={itemId} className="text-[14px] truncate inline-flex flex-row items-center gap-1 text-white">
                    <input
                        checked={isChecked}
                        className="checkbox !rounded-[4px] border-white text-white"
                        id={itemId}
                        onChange={toggle}
                        type="checkbox"
                        disabled={!isChecked && categoryCount >= categories.length}
                    />
                    <span>Compare</span>
                </label>
            </div>
        );
    }

    return isChecked ? (
        <button className={cn('bg-white size-8 rounded-full border-1 border-base-300 flex justify-center items-center cursor-pointer', className)} onClick={toggle}>
            <PhosphorIcon name={'x'} />
        </button>
    ) : null;
}
